import { getConfig } from "./config";

const ACCESS_TOKEN = "access_token";
const REFRESH_TOKEN = "refresh_token";

async function revokeToken(
  token: string | null,
  type: string,
  endpoint: string,
): Promise<void> {
  if (!token) {
    return;
  }
  const data = new FormData();
  data.set("token_type_hint", type);
  data.set("token", token);

  await fetch(endpoint, {
    method: "POST",
    body: new URLSearchParams(data as any),
  });
}

async function revokeTokens(
  accessToken: string | null,
  refreshToken: string | null,
  endpoint: string,
): Promise<void> {
  await Promise.all([
    revokeToken(accessToken, ACCESS_TOKEN, endpoint),
    revokeToken(refreshToken, REFRESH_TOKEN, endpoint),
  ]);
}

export async function logout(configEndpoint?: string) {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem("id_token");

  const endpoint = (await getConfig(configEndpoint)).revocation_endpoint;
  await revokeTokens(accessToken, refreshToken, endpoint);
}
